<template>
  <div>
  
		<div class="container-fluid">
      <div class="page-header" style="padding-top: 15px !important;padding-bottom: 15px !important;">
        <div class="row">
          <div class="col-lg-5">
            <div class="page-header-left" :disabled="loading">
              <!--<h3>{{(breadcrumbsItems.title != '')?breadcrumbsItems.title:breadcrumbsItems.main}}</h3>-->
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link :to="{ path: '/dashboard/default' }"><feather type="home"></feather></router-link></li>
                <li class="breadcrumb-item" v-if="breadcrumbsItems.level1 != ''"><router-link v-if="breadcrumbsItems.level1_to != ''" :to="breadcrumbsItems.level1_to">{{breadcrumbsItems.level1}}</router-link><span v-if="breadcrumbsItems.level1 != '' && breadcrumbsItems.level1_to == ''">{{breadcrumbsItems.level1}}</span></li>
                <li class="breadcrumb-item" v-if="breadcrumbsItems.level2 != ''"><router-link v-if="breadcrumbsItems.level2_to != ''" :to="breadcrumbsItems.level2_to">{{breadcrumbsItems.level2}}</router-link><span v-if="breadcrumbsItems.level2 != '' && breadcrumbsItems.level2_to == ''">{{breadcrumbsItems.level2}}</span></li>
                <li class="breadcrumb-item" v-if="breadcrumbsItems.level3 != ''"><router-link v-if="breadcrumbsItems.level3_to != ''" :to="breadcrumbsItems.level3_to">{{breadcrumbsItems.level3}}</router-link><span v-if="breadcrumbsItems.level3 != '' && breadcrumbsItems.level3_to == ''">{{breadcrumbsItems.level3}}</span></li>
                <li class="breadcrumb-item" v-if="breadcrumbsItems.level4 != ''"><router-link v-if="breadcrumbsItems.level4_to != ''" :to="breadcrumbsItems.level4_to">{{breadcrumbsItems.level4}}</router-link><span v-if="breadcrumbsItems.level4 != '' && breadcrumbsItems.level4_to == ''">{{breadcrumbsItems.level4}}</span></li>
              </ol>
            </div>
          </div>
          <div class="col-lg-7">

            <b-nav-form @submit.prevent="actualizar" class="pull-right">

              <b-input-group size="sm" class="mb-1 ml-0 ml-md-2 mr-0">
                <treeselect v-model="filtro.v2_empresa_id" :clearable="false" :disable-branch-nodes="true" placeholder="Grupo de Trabajo" :disabled="loading" required :options="empresas" 
                :searchable="false" :auto-load-root-options="false" :cache-options="false" @select="cambioEmpresa" :open-on-focus="true" class="module_combo_filter"/>
              </b-input-group>

              <b-input-group size="sm" class="mb-1 ml-0 ml-md-2 mr-0">
                <treeselect v-model="filtro.v2_reporte_id" :clearable="false" :disable-branch-nodes="true" placeholder="Reporte" :disabled="loading" required :options="reportes" 
                :searchable="false" :auto-load-root-options="false" :cache-options="false" @select="cambioReporte" :open-on-focus="true" class="module_combo_filter"
                style="min-width: 300px;"/>
              </b-input-group>

              <ul>
                <li>
                  <a class="text-dark ml-2" href="#" @click.prevent="actualizar"><feather v-b-tooltip.hover title="Actualizar" :disabled="loading" type="refresh-cw"></feather></a>
                </li>
              </ul>

            </b-nav-form>
          </div>
        </div>
      </div>
    </div>
   
		<div class="container-fluid">
			<div class="row">
				<div class="col-md-12">
					<div class="card">
						<div class="card-header p-4">

              <form @submit.prevent="actualizar">

                <div class="form-row" :disabled="loading">

                  <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 mb-0" v-for="ea in report_filters" :key="ea.cs_model">
            
                    <b-form-group class="dynamic_form mb-0" :disabled="loading" :label="ea.cs_label">

                      <treeselect v-if="ea.cs_component === 'select'" 
                        v-model="ea.cs_value" 
                        size="md" 
                        placeholder=""
                        :disabled="false" 
                        :clearable="false" 
                        :disable-branch-nodes="true" 
                        :auto-load-root-options="false" 
                        :cache-options="false" 
                        :open-on-focus="true" 
                        :options="ea.cs_items" 
                        class="module_dynamic_form_combo"/>

                      <treeselect v-if="ea.cs_component === 'relation'"
                        v-model="ea.cs_value"
                        :app_entity="ea.cs_entity"
                        :app_method="ea.cs_method"
                        size="md" 
                        placeholder=""
                        :disabled="false" 
                        :clearable="false" 
                        :disable-branch-nodes="true" 
                        :auto-load-root-options="false" 
                        :cache-options="false" 
                        :open-on-focus="true" 
                        :searchable="true"
                        :load-options="searchFunction" 
                        :async="true" 
                        :default-options="true"
                        :loading-text="'Buscando...'" 
                        :search-prompt-text="'Escriba para buscar'" 
                        class="module_dynamic_form_combo"/>

                      <b-form-input v-if="ea.cs_component === 'input' && ea.cs_type != 'date' && ea.cs_type != 'datetime-local' && ea.cs_type != 'time'" :autofocus="(ea.cs_model=='identificador')?'autofocus':false"
                        v-model="ea.cs_value" 
                        size="md" 
                        :placeholder="ea.cs_placeholder"
                        :type="ea.cs_type" 
                        :step="ea.cs_step" 
                        :min="ea.cs_min" 
                        :max="ea.cs_max" 
                        :pattern="ea.cs_pattern"
                        :maxlength="ea.cs_maxlength"
                        :multiple="ea.cs_multiple"
                        :disabled="false" 
                        class="module_dynamic_form_input"/>

                      <date-range-picker v-if="ea.cs_component === 'input' && (ea.cs_type === 'date' || ea.cs_type === 'datetime-local' || ea.cs_type === 'time')" 
                        id="filtro_fechas" opens="right" :singleDatePicker="false" :timePicker="false" :timePicker24Hour="true" :disabled="loading" 
                        :showWeekNumbers="false" :showDropdowns="true" :autoApply="true" v-model="ea.cs_value" :ranges="undefined" style="width: 100%;">
                        <div slot="input" slot-scope="picker">
                          {{ dateRangePickerMask(picker.startDate) }} - {{ dateRangePickerMask(picker.endDate) }}
                        </div>
                      </date-range-picker>

                    </b-form-group>

                  </div>

                </div>

              </form>

						</div>
						<div class="card-body p-4">
							<div class="table-responsive datatable-vue m-0 vue-smart">
								<v-data-table :headers="headers" :items="items" class="module_data_table" :disabled="loading" 
                  :total-items="totalItems" :pagination.sync="pagination" item-key="id"
                  rows-per-page-text="Registros por página" :rows-per-page-items='[10]'>
                    <template slot="items" slot-scope="props">
                        <td v-for="header in headers" @click="clickRow(props.item)">
                          <span v-if="header.value.includes('fecha')">{{ formatDate(props.item[header.value]) }}</span>
                          <span v-if="header.value.includes('_at')">{{ formatDate(props.item[header.value]) }}</span>
                          <span v-if="!header.value.includes('fecha') && header.value != '_at'">{{ props.item[header.value] }}</span>
                        </td>
                    </template>
                </v-data-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>  

</template>

<script>

import Vue from 'vue';
import moment from 'moment'
import DateRangePicker from '../utils/date_range_picker/DateRangePicker'
const Swal = require('sweetalert2')
import Treeselect from '../utils/vue-treeselect/src/components/Treeselect'
import {es} from 'vuejs-datepicker/dist/locale'
import Datepicker from 'vuejs-datepicker'

export default {
  components: {
    Treeselect,
    DateRangePicker,
    Datepicker
  },
  computed: {
    show_action_button: {
      get: function () {
        if (this.selected.length == 0) {
          return false;
        } else if (this.selected.length == 1) {
          return true;
        } else if (this.selected.length > 1) {
          return true;
        } else {
          return false;
        }
      }
    },
  },
  data () {
    return {
      loading: false,
      reportes: [],
      report_filters: [],
      headers: [],
      items: [],      
      totalItems: 0,
      pagination: {rowsPerPage: 10},
      filtro: {
        enable: "true"
      },
      empresas: [],
      permissions: {},
      breadcrumbsItems: {
        title: 'Reportes',
        level1: 'Reportes',
        level1_to: '',
        level2: 'Visor de Reportes',
        level2_to: '',
        level3: '',
        level3_to: '',
        level4: '',
        level4_to: ''
      },
      format: "dd/MM/yyyy",
      es: es
    }

  },
  watch: {
    pagination: {
      handler () {
        if (this.items.length > 0) {

          var data = {}
          data.limit = this.pagination.rowsPerPage
          data.page = this.pagination.page
          data.ascending = !this.pagination.descending
          data.orderBy = this.pagination.sortBy
          data.query = this.filtro
          
          /*this.getReportes_rows(this.filtro.v2_empresa_id,data)
            .then(data => {
              this.items = data.items
              this.totalItems = data.total
            })*/
        }
      },
      deep: true
    }
  },
  mounted() {
    this.getEmpresas()
      .then(data => {
        this.empresas = data.items
        
        if(localStorage.empresa_id > 0){
          this.filtro.v2_empresa_id = localStorage.empresa_id
          this.cambioEmpresa(localStorage.empresa_id)
        } else {
          if(data.items.length > 0){
            this.filtro.v2_empresa_id = data.items[0].id
            this.cambioEmpresa(data.items[0].id)
          }
        }
      })
  },
  created () {
    try {
      if (!localStorage.signedIn) {
        this.$router.push('/')
      } else {

        localStorage.page_return = ""

        //valido permisos
        var accesos = JSON.parse(localStorage.accesos)
        accesos.forEach(acceso => {
          if(acceso.model == "case"){
            this.permissions[acceso.permission] = true
          }
        });
      }  
    } catch (error) {
      this.showError(error)
    }
  },
  methods: {
    cambioEmpresa (empresa){

      var v2_empresa_id = undefined

      if ( empresa.id ) {
        v2_empresa_id = empresa.id
      } else {
        v2_empresa_id = empresa        
      }

      localStorage.empresa_id = v2_empresa_id

      this.getReportesPorEmpresa(v2_empresa_id)
      .then(data => {
        this.reportes = data.items
      })

      this.limpiar()
    },
    cambioReporte (reporte){

      var v2_reporte_id = undefined

      if ( reporte.id ) {
        v2_reporte_id = reporte.id
      } else {
        v2_reporte_id = reporte        
      }

      this.filtro.v2_reporte_id = v2_reporte_id

     this.getReporteFiltrosForView(v2_reporte_id,this.filtro.v2_empresa_id)
      .then(data => {
        this.report_filters = data.items
      })

    },
    actualizar () {

      if (this.filtro.v2_reporte_id > 0) {
        var data = {}
        data.limit = this.pagination.rowsPerPage
        data.page = this.pagination.page
        data.ascending = !this.pagination.descending
        data.orderBy = this.pagination.sortBy
        data.type = "getReporte_Viewer"
        data.v2_reporte_id = this.filtro.v2_reporte_id

        this.report_filters.forEach(element => {

          if (element.cs_value && element.cs_entity == null) {
            if (element.cs_type == 'datetime-local' || element.cs_type == 'date' || element.cs_type == 'time') {
              element.cs_value.startDate = this.dateRagePickerToUTC(element.cs_value.startDate)
              element.cs_value.endDate = this.dateRagePickerToUTC(element.cs_value.endDate)
            } else {
              element.cs_value = this.cs(element.cs_value)
            }
          }
          
        });

        data.query = this.report_filters
        
        this.getReporte_Viewer(this.filtro.v2_empresa_id, data)
        .then(data => {
          console.log(data)
          this.headers = data.result.headers
          this.items = data.result.items
          this.totalItems = data.result.total
        })
      } else {
        this.showError("Debe seleccionar un reporte")
      }
      
    },
    searchFunction ({ action, searchQuery, app_entity, app_method, callback }) {

      /*

          EN ESTA PARTE DE LAS FUENTES DEL TREESELECT HICE EL CAMBIO

          /home/sadcorpcrm/sadcorpcrm-frontend/node_modules/@riophae/vue-treeselect/dist/vue-treeselect.js:757: 
          /home/sadcorpcrm/sadcorpcrm-frontend/node_modules/@riophae/vue-treeselect/dist/vue-treeselect.js:1412:  


          app_value: {
            type: Number
          },
          app_entity: {
            type: String
          },
          app_method: {
            type: String
          },
          
           this.callLoadOptionsProp({
            action: ASYNC_SEARCH,
            args: {
              searchQuery: searchQuery,
              app_value: this.app_value,
              app_entity: this.app_entity,
              app_method: this.app_method
            },
      */
      try {

        var items = []

        if (action === "ASYNC_SEARCH" && this.filtro.v2_empresa_id != undefined) { 

          var url = ''

          if (app_entity == 'v2_empresas') {
            url = '/desk/client/v1/'+ app_entity +'/'
          } else {
            url = '/desk/client/v1/v2_empresas/'+ this.filtro.v2_empresa_id +'/'+ app_entity +'/'
          }

          this.$http.secured.get(url, { params: { type: app_method, searchQuery: searchQuery } })
          .then(response => {
            if (response.data) {  
              response.data.forEach(element => {
                items.push({ id: element.id, label: element.name })
              });
            }
            callback(null, items)
          })
          .catch(error => {
            callback(null, items)
            this.showError(error)
          })
        } else {
          callback(null, items)
        }
      } catch (error) {
        this.showError(error)
      }
    },
    cs (str){
      return str.trim().replace(/'/g, ' ').replace(/"/g, " ").replace(/\t/g, ' ')
    },
    limpiar () {

      this.headers = []
      this.items = []
      this.report_filters = []
      this.totalItems = 0
      this.pagination = {rowsPerPage: 10}

    },
    clickRow (row) {
      /*var insert = true;
      for (let index = 0; index < this.selected.length; index++) {
        const element = this.selected[index];
        if (element.id == row.id) {
          insert = false;
          this.selected.splice(index, 1); 
          break;
        }
      }
      if (insert) {
        this.selected.push(row)
      }*/
    },

  }
}
</script>
